import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Tooltip } from '@material-ui/core';
import { useMeContext } from '~/modules/me';
import { useHasPermission } from '~/modules/common/permissions';
import { ResourceAllocationStatus } from '~/types';
import QuickAllocationActions from '~/modules/quickAllocation/components/QuickAllocationUserChart/components/QuickAllocationActions';
import QuickAllocationActions2 from '~/modules/quickAllocation/components/QuickAllocationUserChart/components/QuickAllocationActions/QuickAllocationsActions2';

const useStyles = makeStyles(theme => ({
  root: {
    ...theme.typography.body2,
    flexGrow: 1,
    flexShrink: 1,
    alignSelf: 'stretch',
    padding: theme.spacing(0),
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    alignItems: 'center',
    justifyContent: 'flex-start',
    textTransform: 'none',
    overflow: 'hidden',
    margin: theme.spacing(0)
  },
  row: {
    ...theme.typography.caption,
    display: 'flex',
    flexGrow: 0,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    lineHeight: `${theme.spacing(1)}px`,
    width: theme.spacing(43.75),
    padding: theme.spacing(0, 0.5)
  },
  rowCell: {
    display: 'flex',
    alignItems: 'center',
    flexGrow: 1,
    flexDirection: 'row'
  },
  role: {
    justifyContent: 'flex-end'
  },
  text: {
    ...theme.typography.caption,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    padding: theme.spacing(1)
  },
  projectText: {
    fontWeight: theme.typography.fontWeightBold,
    maxWidth: theme.spacing(25)
  },
  roleText: {
    maxWidth: theme.spacing(15),
    wordBreak: 'break-word',
    textAlign: 'right'
  },
  actionPlaceHolder: { width: theme.spacing(4) }
}));

const QuickAllocationProjectGroupLeftComponent = ({
  resourceAllocation,
  resourceUser,
  allocationSort,
  scale
}) => {
  const classes = useStyles();
  const isCompleteResourceAllocationPermissionEnabled = useHasPermission({
    actionUri: 'urn:replicon-webui:completed-resource-allocation:edit'
  });
  const {
    featureFlags: { isPSAActualCornerCasesEnabled }
  } = useMeContext();

  return (
    <div className={classes.root}>
      <div className={classes.row}>
        {resourceAllocation.allocationStatus ===
          ResourceAllocationStatus.Committed &&
        isCompleteResourceAllocationPermissionEnabled ? (
          isPSAActualCornerCasesEnabled ? (
            <QuickAllocationActions2
              user={resourceUser}
              resourceAllocation={resourceAllocation}
            />
          ) : (
            <QuickAllocationActions
              resourceAllocation={resourceAllocation}
              resourceUser={resourceUser}
              allocationSort={allocationSort}
              scale={scale}
            />
          )
        ) : (
          <div className={classes.actionPlaceHolder} />
        )}
        <div className={classes.rowCell}>
          <Tooltip title={resourceAllocation.project.displayText}>
            <span className={classNames(classes.text, classes.projectText)}>
              {resourceAllocation.project.displayText}
            </span>
          </Tooltip>
        </div>
        <div className={classNames(classes.rowCell, classes.role)}>
          <Tooltip
            title={
              resourceAllocation?.role?.displayText
                ? resourceAllocation.role.displayText
                : ''
            }
          >
            <span className={classNames(classes.text, classes.roleText)}>
              {resourceAllocation.role &&
              resourceAllocation.role.displayText ? (
                resourceAllocation.role.displayText
              ) : (
                <FormattedMessage id="quickAllocation.noRole" />
              )}
            </span>
          </Tooltip>
        </div>
      </div>
    </div>
  );
};

QuickAllocationProjectGroupLeftComponent.propTypes = {
  resourceAllocation: PropTypes.object,
  resourceUser: PropTypes.object,
  allocationSort: PropTypes.object,
  scale: PropTypes.string
};

export default QuickAllocationProjectGroupLeftComponent;
